<template>
  <div class="single_list d-flex justify-content-between flex-wrap">
    <p>
      <b-avatar
          v-if="false"
        badge
        badge-variant="success"
        :src="family.user ? family.user.imgURL : ''"
        :alt="family.nickname"
      />
      <b-avatar
          v-else
          :src="family.user ? family.user.imgURL : ''"
          :alt="family.nickname"
      />
    </p>
    <p>{{ relation }} {{ name }}</p>
    <p>Status: {{ status }}</p>
    <div class="list_details"></div>
  </div>
</template>

<script>
export default {
  props: {
    family: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    name() {
      return this.family.nickname ? this.family.nickname : "";
    },
    relation() {
      return this.family.relation ? this.family.relation : "";
    },
    status() {
      return this.family.status && this.family.status.status
        ? this.family.status.status
        : "";
    }
  },
  data() {}
};
</script>

<style lang="scss" scoped>
img {
  width: 50px;
  height: 50px;
  min-height: 100px;
  object-fit: cover;
}
.single_list {
  align-items: center;
  // padding: 20px;
  border-bottom: 1px solid #ddd;
  height: 78px;
  @media (max-width: 875px) {
    height: 90px;
  }
  p {
    font-style: normal;
    font-weight: 600;
    font-size: 16px;

    display: flex;
    align-items: center;
    color: #474d52;
    margin: 0;
    margin-left: 24px;
    @media (max-width: 875px) {
      margin-top: 10px;
    }
  }
  .list_details {
    display: flex;
    align-items: center;
    .sub_price {
      margin-right: 68px;
      font-style: normal;
      font-weight: 600;
      font-size: 16px;
      line-height: 22px;

      display: flex;
      align-items: center;

      /* Body */

      color: #474d52;
      @media (max-width: 875px) {
        margin-left: 24px;
      }
      @media (max-width: 460px) {
        margin-right: 5px;
      }
    }
    .email_btn {
      margin-right: 16px;
      @media (max-width: 450px) {
        margin-right: 10px;
      }
    }
    .email_btn,
    .download_btn {
      background: rgba(85, 126, 251, 0.1);
      border-radius: 4px;
      // max-width: 87px;
      // width: 100%;
      height: 36px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      color: var(--theme-color);
      border: none;
      margin-left: 12px;

      @media (max-width: 450px) {
        margin-left: 0px;
      }
      span {
        padding-right: 8px;
      }
      &:focus {
        outline: none;
        border: none;
      }
    }
    .download_btn:hover {
      background: rgba(85, 126, 251, 0.1) !important;
    }
    .download_btn {
      // max-width: 89px;
      height: 43px;
      width: 100%;
      // justify-content: flex-start;
      background: none;
      margin-right: 24px;
      @media (max-width: 460px) {
        margin-right: 5px;
      }
    }
  }
}
</style>
